<template>
  <v-container fluid>
    <v-row>
      <v-col :cols="image ? 8 : 12">
        <v-text-field
          ref="name"
          label="Nome Immagine"
          v-model="name"
          :rules="[rules.required]"
        />
        <v-file-input ref="image" v-model="image" :rules="[rules.required]" />
      </v-col>
      <v-col cols="4">
        <v-img v-if="imageUrl" :src="imageUrl" />
      </v-col>
      <v-col cols="12">
        <v-btn
          :disabled="!name || !image || loading"
          :dark="!(!name || !image)"
          class="col-12"
          color="green"
          @click="confirm"
          >Carica</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UploadGeneric",
  data() {
    return {
      name: "",
      image: null,
      imageUrl: null,
      loading: false,
      rules: {
        required: value => !!value || "Campo Obbligatorio"
      }
    };
  },
  methods: {
    async confirm() {
      if (!this.name || !this.image) {
        this.$refs["name"].validate(true);
        this.$refs["image"].validate(true);
      } else {
        this.loading = true;
        let formData = new FormData();

        formData.append("image", this.image);
        formData.append("name", this.name);

        let response = await fetch(`${process.env.VUE_APP_BACKEND}/media/`, {
          method: "POST",
          body: formData,
          timeout: 0
        });
        console.log(response);
        this.loading = true;
        this.$emit("completed");
      }
    }
  },
  watch: {
    image: function() {
      this.imageUrl = URL.createObjectURL(this.image);
    }
  }
};
</script>

<style scoped></style>
